module.exports = __webpack_public_path__ + "img/template_2.c4dd309d.png";